export default "__VITE_ASSET__Dmd9vLDg__"